import { Box } from '@mui/material'
import React from 'react'
import { TableCellProps } from 'react-virtualized'

import CellLink from 'src/components/Table/Cells/CellLink'
import { useProviders } from 'src/layout/hooks'

interface IProviderCell extends TableCellProps {
  field: 'name' | 'id'
}

export function ProviderCell({ cellData, field }: IProviderCell) {
  const { activeProviders } = useProviders()

  const providerValue = cellData as string
  const provider = activeProviders.find((p) => p[field] === providerValue)

  if (!provider) {
    return <div>{providerValue}</div>
  }

  return (
    <CellLink url={`/providers/${provider.id}`}>
      <Box
        style={{
          backgroundImage: `url(${provider?.logo || '/img/img-placeholder.svg'})`,
          textAlign: 'center',
          height: 25,
          maxHeight: 25,
          maxWidth: 80,
          width: '100%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </CellLink>
  )
}
